export const MAIN_PATHS = {
	HOME: '/',
	NOT_FOUND: '/404',
	OFFER_CONFIGURATOR: '/wybierz-pakiet',
	PASSWORD_RESET: '/reset-hasla',
	PAYMENT_VERIFICATION: '/transakcja/return',
	STATIC: '/strona/:alias',
	CONTACT: '/kontakt',
	DOCUMENTS: '/dokumenty'
};
